import { FormControlLabel, Switch } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
// import { styled } from '@mui/material/styles';
import { Tooltip } from 'antd';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { get } from 'lodash';
import { resource_types } from 'store/extraResource/constants';
import * as Sentry from '@sentry/react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import Typography from '@mui/material/Typography';

const RESOURCE_TYPE_LABELS = {
  [resource_types.resource]: '1Way Resource',
  [resource_types.story]: '1Way Story',
  [resource_types.informate]: 'Informate',
  [resource_types.balcon]: 'Balcón Cultural',
  [resource_types.conectándome]: 'Conectándome',
  [resource_types.comunidad]: 'Comunidad',
  [resource_types.AP]: 'AP',
};

const RESOURCE_TYPE_BADGE_THEME = {
  [resource_types.resource]: { bg: '#E3F2FD', color: '#1565C0' },
  [resource_types.story]: { bg: '#F3E5F5', color: '#7B1FA2' },
  [resource_types.informate]: { bg: '#E8F5E9', color: '#2E7D32' },
  [resource_types.balcon]: { bg: '#FFF3E0', color: '#E65100' },
  [resource_types.conectándome]: { bg: '#E0F7FA', color: '#00695C' },
  [resource_types.comunidad]: { bg: '#FCE4EC', color: '#C2185B' },
  [resource_types.AP]: { bg: '#EDE7F6', color: '#4527A0' },
};
import { useExtraResourceEbook } from 'store/extraResource/selectors';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { updateUI } from 'store/UI/actions';
import styled from 'styled-components';
import color from 'utils/constants/color';
import { extensionActivityIcon } from '../helper';
import useBook from 'components/hooks/books/useBook';
import {
  generatePageRange,
  getBookDataByID,
  RESOURCE_BOOK_ID_MAP,
} from 'modules/assignments/helper';
import { styled as muiStyled } from '@mui/material/styles';
import { extenionGetPageData } from 'utils/lib/ebookHelper';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';
import extensionActivity from 'utils/assets/images/extensionActivity.svg';

const ExtensionActivitiesTooling = ({ pageId }) => {
  const dispatch = useDispatch();
  const [showActivity, setShowActivity] = useState(false);
  const classes = useStyles();
  const extraResource = useExtraResourceEbook();
  const location = useLocation();
  const orgPermissions = useCurrentOrgPermission();
  const nodeRef = React.useRef(null);
  const showAlert = useAlert();
  const { resource, balcon, conectándome, comunidad, informate, story, AP } = resource_types;
  const bookState = useBook();
  const {updatePopUpAtOnce,checkPopUpAtOnce,openPopUpAtOnce} = usePopUpAtOnce();

  useEffect(() => {
    dispatch(updateUI({ extensionActivity: { open: false } }));
  }, [location.pathname]);

  const filterExtraResource = useMemo(() => {
    if (extraResource) {
      return extraResource?.filter((item) => item?.pageId == pageId) || [];
    } else {
      return [];
    }
  }, [pageId, extraResource]);

  useEffect(() => {
    setShowActivity(false);
  }, [pageId]);

  const handleGenerator = async (element) => {
    try {
      const payload = {
        open: true,
        ...element,
      };
      if (element?.resource_type === informate) {
        const orgPermission = get(orgPermissions, '1nformate', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access Informate.', 'error');
        }
      } else if (element?.resource_type === resource) {
        const orgPermission = get(orgPermissions, '1WAYRESOURCES', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access 1WAYRESOURCES.', 'error');
        }
      } else if (element?.resource_type === story) {
        const orgPermission = get(orgPermissions, '1WAYSTORY', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access 1WAYSTORY.', 'error');
        }
      } else if (element?.resource_type === AP) {
        const orgPermission = get(orgPermissions, 'ap', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access ap.', 'error');
        }
      } else if (element?.resource_type === comunidad) {
        const orgPermission = get(orgPermissions, 'comunidad', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access comunidad resources.', 'error');
        }
      } else if (element?.resource_type === conectándome) {
        const orgPermission = get(orgPermissions, 'conectandome', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access Informate resources.', 'error');
        }
      } else if (element?.resource_type === balcon) {
        const orgPermission = get(orgPermissions, 'balcónCultural', true);
        if (!orgPermission) {
          return showAlert('You do not have permission to access Informate resources.', 'error');
        }
      }
      await dispatch(updateUI({ extensionActivity: payload }));
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const getAssignedCount = (element) => {
    let adminAssignedActivityCount = 0;
    let adminAssignedQuizCount = 0;
    if (element?.resource_type === AP) {
      const bookId = element?.config?.selectedCategoryAP?.chapter_ids;
      const bookData = getBookDataByID(bookState, bookId);
      const pageData = extenionGetPageData(
        bookData,
        pageId,
        bookState?.quiz,
        bookState?.activity,
        null,
        bookId,
        {
          [bookId]: generatePageRange(
            element?.config?.selectedItems[0]?.start,
            element?.config?.selectedItems[0]?.finish,
          ),
        },
        'extensionActivity',
      );
      adminAssignedActivityCount =
        pageData?.availableActivity?.filter((item) => item?.data.type !== 'custom')?.length || 0;
      adminAssignedQuizCount =
        pageData?.availableQuiz?.filter((item) => item?.data.type !== 'custom')?.length || 0;
    } else if (element?.resource_type === story) {
      const bookId = element?.config?.selectedItems[0]?.bookId;
      const bookData = getBookDataByID(bookState, bookId);
      const findLevel = element?.config?.selectedItems[0]?.levels?.find(
        (item) => item?.level === element.config.level,
      );
      const pageData = extenionGetPageData(
        bookData,
        pageId,
        bookState?.quiz,
        bookState?.activity,
        null,
        bookId,
        {
          [bookId]: generatePageRange(findLevel?.start, findLevel?.finish),
        },
        'extensionActivity',
      );

      adminAssignedActivityCount =
        pageData?.availableActivity?.filter(
          (item) => item?.data.type !== 'custom' && item?.data?.level === element.config.level,
        )?.length || 0;
      adminAssignedQuizCount =
        pageData?.availableQuiz?.filter(
          (item) => item?.data.type !== 'custom' && item?.data?.level === element.config.level,
        )?.length || 0;
    } else if (
      element?.resource_type === comunidad ||
      element?.resource_type === conectándome ||
      element?.resource_type === balcon ||
      element?.resource_type === informate
    ) {
      const bookId = RESOURCE_BOOK_ID_MAP[element.resource_type];
      const bookData = getBookDataByID(bookState, bookId);
      const pageData = extenionGetPageData(
        bookData,
        pageId,
        bookState?.quiz,
        bookState?.activity,
        null,
        bookId,
        {
          [bookId]: generatePageRange(
            element?.config?.selectedItems[0]?.start,
            element?.config?.selectedItems[0]?.finish,
          ),
        },
        'extensionActivity',
      );
      adminAssignedActivityCount =
        pageData?.availableActivity?.filter(
          (item) => item?.data.type !== 'custom',
        )?.length || 0;
      adminAssignedQuizCount =
        pageData?.availableQuiz?.filter((item) => item?.data.type !== 'custom')?.length || 0;
    } else if (element?.resource_type === resource) {
      const bookId = element?.config?.selectedItems[0]?.id;
      const bookData = getBookDataByID(bookState, bookId);
      adminAssignedActivityCount =
        bookData?.classActivities?.filter((item) => item?.data.type !== 'custom')?.length || 0;
      adminAssignedQuizCount =
        bookData?.classQuizzes?.filter((item) => item?.data.type !== 'custom')?.length || 0;
    }
    const totalAdminAssignedCount = adminAssignedActivityCount + adminAssignedQuizCount;

    return {
      adminAssignedActivityCount: totalAdminAssignedCount,
    };
  };

  if (filterExtraResource?.length === 0) return null;

  const StyledSwitch = muiStyled(Switch)({
    '&.MuiSwitch-sizeSmall': {
      width: "40px",
      height: "25px",
    },
    '& .Mui-checked': {
      transform: "translateX(17px) !important",
    }
  });

  return (
    <SentryWrap>
      <div className="relative">
                <FormControlLabel
          classes={{
            root: classes.root,
            label: `${classes.label} ${classes.additionalSupportLabel}`,
          }}
          control={
            <StyledSwitch
              classes={{
                sizeSmall: classes.sizeSmall,
                checked: classes.checkedSwitch,
              }}
              checked={showActivity}
              onChange={async (e) => {
                if(e.target.checked){
                  if(openPopUpAtOnce){ 
                    checkPopUpAtOnce();
                    return;
                  }
                  updatePopUpAtOnce(true);
                  setShowActivity(true);
                }else if(!e.target.checked){
                  dispatch(updateUI({ extensionActivity: {} }));
                  updatePopUpAtOnce(false);
                  setShowActivity(false);
                }
              } }
              name="viewTeacherEdition"
              color="primary"
              size="small"
            />
          }
          label="Extension activities"
        />

        {showActivity && (
        <Accordion defaultExpanded={true} sx={{
          minHeight: "37px",
          }} className="extensionActivityAccordian">
        <AccordionSummary
          
          expandIcon={<KeyboardDoubleArrowDownIcon sx={{color:'#0059ff'}} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="extensionActivitySummary"
          onClick={() => {
            dispatch(updateUI({ extensionActivity: {} })); 
            setShowActivity(false); 
            updatePopUpAtOnce(false); 
          }}
          sx={{display: 'flex', alignItems: 'center', gap: '10px', minHeight: '37px', "&.Mui-expanded": {
            minHeight: "37px",
          } }}
        >
          <div style={{display: 'flex', alignItems: 'center', gap: '2px'}}>
            <img src={extensionActivity} alt="extensionActivity" width={30} height={30} />
            <Typography>EXTENSION ACTIVITIES</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{padding: '0px'}}>

        <CSSTransition
          in={showActivity}
          timeout={300}
          classNames="fade"
          unmountOnExit
          nodeRef={nodeRef}
          className="etxActvtyDropDwn"
        >
          <LinkContainer ref={nodeRef}>
            {filterExtraResource?.map((element, index) => {
              const { adminAssignedActivityCount } = getAssignedCount(element);
              const isLast = index === filterExtraResource.length - 1;
              const rt = element?.resource_type;
              const typeLabel = RESOURCE_TYPE_LABELS[rt] || rt || '—';
              const badgeTheme = RESOURCE_TYPE_BADGE_THEME[rt] || {
                bg: '#ECEFF1',
                color: '#37474F',
              };

              return (
                <LinkItem onClick={() => handleGenerator(element)} key={index} $isLast={isLast}>
                  {element?.config?.key ? (
                    <img
                      src={
                        extensionActivityIcon?.find((data) => data?.type === element?.config?.key)
                          ?.imageUrl
                      }
                      width={15}
                      height={15}
                      alt="icon"
                    />
                  ) : (
                    <img
                      src={
                        extensionActivityIcon?.find((data) => data?.type === element?.config?.key)
                          ? extensionActivityIcon?.find(
                              (data) => data?.type === element?.config?.key,
                            )?.imageUrl
                          : extensionActivityIcon[0]?.imageUrl
                      }
                      alt="icon"
                    />
                  )}

                  <LinksItem as="div">
                    <TitleRow>
                      <Tooltip placement="top" title={element?.config?.title || ''}>
                        <TitleText>{element?.config?.title}</TitleText>
                      </Tooltip>
                      {adminAssignedActivityCount ? (
                        <AssignedCount>{` (${adminAssignedActivityCount?.toString()} Assigned)`}</AssignedCount>
                      ) : null}
                    </TitleRow>
                    <ResourceTypeBadge $bg={badgeTheme.bg} $fg={badgeTheme.color}>
                      {typeLabel}
                    </ResourceTypeBadge>
                  </LinksItem>
                </LinkItem>
              );
            })}
          </LinkContainer>
        </CSSTransition>
        </AccordionDetails>
        </Accordion>
        )}
      </div>
    </SentryWrap>
  );
};

export default ExtensionActivitiesTooling;

const useStyles = makeStyles({
  root: {
    margin: '5px',
    // width: '175px'
  },
  sizeSmall: {
    width: "50px",
    height: "25px",
  },
  checkedSwitch: {
    transform: 'translateX(20px) !important',
  },
  label: {
    textTransform: 'uppercase',
  },
  teacher_stag_root: {
    margin: '5px',
  },
});

const LinkContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  max-height: 300px;
  overflow: auto;
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #ffffff 50%,
    #eef3fb 75%,
    #e3ebf6 100%
  ) !important;
   padding: 0px 10px;
  
  border-radius: 24px;
  z-index: 11;
  top: 21px;
  left: 0;
  overflow-x: hidden;
  &.fade-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 300ms,
      transform 300ms;
  }
  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }
  &.fade-exit-active {
    opacity: 0;
    transform: translateY(-10px);
    transition:
      opacity 300ms,
      transform 300ms;
  }
`;

const LinkItem = styled.div`
  margin-bottom: 5px;
  color: #fff;
  display: flex;
  align-items: flex-start;
  gap: 7px;
  background-color: transparent;
  padding-top: 6px;
  padding-bottom: ${(props) => (props.$isLast ? '0' : '6px')};
  border-bottom: ${(props) => (props.$isLast ? 'none' : '1px solid rgba(255, 255, 255, 0.2)')};
  padding-left: 10px;
  cursor: pointer;
  img {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

const LinksItem = styled.div`
  color: #000;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  transition: opacity 0.2s;
  display: block;
  &:hover {
    opacity: 0.85;
  }
`;

const TitleRow = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
`;

const TitleText = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  color: #000;
  font-size: 12.5px;
  font-weight: 400;
  font-style: normal;
  line-height: 17px;
`;

const AssignedCount = styled.span`
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12.5px;
  font-weight: 400;
  line-height: 17px;
`;

const ResourceTypeBadge = styled.span`
  margin-top: 6px;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  line-height: 1.2;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
`;
